import { createContext } from 'react'

const MultiImagesContext = createContext<boolean>(false)

export default MultiImagesContext
